import { Component, OnInit, Inject, Input } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { PracticeService } from 'src/app/services/practice.service';
import { Account } from 'src/app/models/account';

@Component({
  selector: 'app-add-member-programme',
  templateUrl: './add-member-programme.component.html',
  styleUrls: ['./add-member-programme.component.scss']
})
export class AddMemberProgrammeComponent implements OnInit {
  public addError:string = null;
  public loadedUsers: boolean = false;
  public users: any[];
  public selectedUsers = [];
  public allSelected: boolean = false;
  public disabledList: number[] = [];
  constructor(public dialogRef: MatDialogRef<AddMemberProgrammeComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any, private practiceService:PracticeService) {
    }

  ngOnInit() {
    this.practiceService.getMembers().subscribe(users=>{
      this.users=users;
      this.disabledList=this.data.preSelected;
      if(users.length==0){
        this.addError = "You do not have any members in your practice";
      }
      this.loadedUsers = true;
    })
  }

  cancel(){
    this.dialogRef.close(false);
  }

  add(){
    this.dialogRef.close(this.selectedUsers);
  }

  submit(){

  }

  toggleUser(selected_id){
    let existingUser=this.selectedUsers.filter(id=>{
      return id==selected_id;
    })[0];

    if(existingUser){
      this.selectedUsers = this.selectedUsers.filter(id=>{
        return id!=existingUser;
      })
    }
    else{
      this.selectedUsers.push(selected_id);
    }
  }

  selectAll(){
    this.selectedUsers = [];

    if(this.allSelected){
      this.allSelected = false;
    }
    else{
      this.users.forEach(user=>{
        if(!this.disabledList.includes(user.id)){
          this.selectedUsers.push(user.id);
        }
      });
      this.allSelected = true;
    }
  }
}
